import { render, staticRenderFns } from "./PatientPlansComponent.vue?vue&type=template&id=6a1104d0&scoped=true"
import script from "./PatientPlansComponent.vue?vue&type=script&lang=ts"
export * from "./PatientPlansComponent.vue?vue&type=script&lang=ts"
import style0 from "./PatientPlansComponent.vue?vue&type=style&index=0&id=6a1104d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1104d0",
  null
  
)

export default component.exports